import *  as TYPES from '../mutation-types'

export default {
  state: {
    count: 0,
  },

  mutations: {
    [TYPES.LOGIN](state, {cart_count}) {
      state.count = cart_count;
    },

    [TYPES.ADD_CART](state, count) {
      state.count = count;
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/cart.js